import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBg,
  smTitleStyle,
  SvgComponent,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";
import { ReactComponent as Background } from "./bga.svg";
import zIndex from "@mui/material/styles/zIndex";
import FadeIn from "../../../Components/FadeIn";

export default function Header() {
  const small = useMediaQuery(`(max-width:480px)`);
  const minHeight = small ? "auto" : "700px";

  const medium = useMediaQuery(`(max-width:900px)`);

  return (
    <div style={{ position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "50vw",
          minWidth: "50vw",
          bgcolor: colorApp,
          minHeight: "700px",
          maxHeight: "700px",
          display: { xs: "none", sm: "inline" },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "50vw",
          minWidth: "50vw",
          bgcolor: colorBg,
          minHeight: "700px",
          maxHeight: "700px",
          display: { xs: "none", sm: "inline" },
        }}
      />

      <div style={{ overflowX: "hidden", overflowY: "visible", width: "100%" }}>
        <Box
          sx={{
            position: "relative",
            minHeight,
            overflow: "hidden",
            bgcolor: colorApp,
          }}
        >
          {!small && (
            <SvgComponent
              svg={<Background />}
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: `translate(${medium ? "-10" : "-40"}%, 0)`,
                minHeight: "750px",
                maxHeight: "750px",
                minWidth: "0px",
                maxWidth: "2200px",
                zIndex: 3,
              }}
              sx={{ zIndex: 3 }}
            />
          )}
          <Container
            maxWidth="lg"
            sx={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
              zIndex: 5,
              pt: "220px",
              minHeight,
            }}
          >
            <FadeIn>
              <Box sx={{}}>
                <Typography
                  sx={{
                    ...smTitleStyle,
                    color: colorBg,
                    textAlign: "left",
                  }}
                >
                  Kdo jsme?
                </Typography>

                <Typography
                  sx={{
                    ...titleStyle,
                    color: colorBg,
                    textAlign: "left",
                    mt: "14px",
                  }}
                >
                  S Čumákem Na Stopě
                </Typography>
                <Typography
                  sx={{
                    ...textStyle,
                    color: colorBg,
                    textAlign: "left",
                    maxWidth: "350px",
                    mt: "14px",
                    pb: "60px",
                  }}
                >
                  Toto je ten jediný nejlepší zdroj informací o… Ne, takto
                  opravdu ne. Takto to fungovat nebude a o tom je vlastně
                  projekt S Čumákem Na Stopě. Projekt, který je veden s úctou a
                  pokorou, se zájmem spojovat lidi v kynologii a celé toto
                  prostředí přednést jako krásný sport, zálibu, hobby… Projekt,
                  který Vám doufáme přinese nové informace, ponaučení, lepší
                  pohled na celé toto odvětví a v neposlední řadě spoustu zábavy
                  a srandy. Pojďte do toho s námi. Pojďte si za tím, co Vás
                  baví. Pojďte S Čumákem Na Stopě.
                </Typography>
              </Box>
            </FadeIn>
            <Box
              sx={{
                ml: "auto",
                display: "flex",
                alignItems: "flex-end",
                alignContent: "flex-end",
              }}
            >
              {/*<Box
              component={"img"}
              src={collage}
              sx={{
                maxWidth: { xs: "0", sm: "0", md: "320px", lg: "480px" },
                display: { xs: "none", sm: "none", md: "inline" },
                mb: "24px",
              }}
            ></Box>*/}
            </Box>
          </Container>
        </Box>
      </div>
    </div>
  );
}
